import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeading } from "@/components/marketing/SectionHeading";

const faqs = [
  {
    question: "What is Sellaris?",
    answer: "Sellaris is an AI-powered sales training platform built for Sales Programs and Enterprise sales teams. It provides realistic role-play practice with AI buyers, instant feedback based on proven judging rubrics, and progress tracking to help reps and students sharpen their sales skills at scale.",
  },
  {
    question: "How does the AI buyer work?",
    answer: "Our AI buyers are trained on real sales competition scripts and respond dynamically to your questions and pitches. They simulate realistic buyer behavior including objections, information revelation based on your discovery questions, and natural conversation flow.",
  },
  {
    question: "What scoring criteria do you use?",
    answer: "We use proven sales judging rubrics tailored to your context — collegiate competition rubrics for Sales Programs, and customizable enterprise rubrics (discovery, qualification, objection handling, close, communication, and overall performance) for Enterprise teams. Each category is scored with specific feedback on how to improve.",
  },
  {
    question: "Can I practice with voice?",
    answer: "Yes! Sellaris supports full voice conversation mode using advanced speech-to-text technology. You can conduct entire role-plays by speaking naturally, just like you would in an actual competition. The AI buyer also responds with synthesized voice for a realistic experience.",
  },
  {
    question: "What is 'Stay in the Ring' mode?",
    answer: "Stay in the Ring is our challenge mode for objection handling practice. In this mode, if you give a weak response to an objection (not following the Clarify-Address-Confirm framework), the session ends immediately. It's designed to build mental toughness and ensure you're ready for pressure situations.",
  },
  {
    question: "How is this different from practicing with friends?",
    answer: "Sellaris provides several advantages: 24/7 availability, consistent buyer behavior based on competition scripts, instant structured feedback using official rubrics, detailed analytics to track improvement over time, and the ability to practice specific scenarios repeatedly without social awkwardness.",
  },
  {
    question: "Do I need any special equipment?",
    answer: "Just a computer with a microphone. All practice is done in voice mode for the most realistic experience.",
  },
  {
    question: "Can professors, coaches, or sales leaders use this with their teams?",
    answer: "Yes. We offer Sales Programs plans for universities and Enterprise plans for sales organizations — including team dashboards, custom scenarios, role-based analytics, and volume licensing tailored to your curriculum or playbook.",
  },
  {
    question: "What use cases does Sellaris support?",
    answer: "Sellaris supports Sales Programs preparing students for major collegiate competitions (NCSC, ICSC, regionals) and Enterprise sales teams onboarding, certifying, and continuously coaching reps on real-world deals. The underlying sales skills — discovery, objection handling, and closing — apply universally.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="py-20 sm:py-28 relative">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <SectionHeading
          eyebrow="FAQ"
          title="Frequently asked questions"
          description="Everything you need to know before your first session."
        />

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="divide-y divide-[hsl(var(--border-subtle))] border-y border-subtle">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border-none"
              >
                <AccordionTrigger className="text-left font-sans text-[0.95rem] sm:text-base font-medium hover:no-underline py-5 gap-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-sans text-sm sm:text-[0.95rem] leading-relaxed pb-5 max-w-2xl">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
